import { UserService } from "@/services";

export const submitOrderRoutes = [
  {
    path: ":id/deposit",
    name: "deposit-process",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.orderProcess.depositProcess"
    },
    component: () =>
      import(
        /* webpackChunkName: "deposit-process" */ "@/components/OrderProcessPage/Deposit/index"
      )
  },
  {
    path: ":id/offline-deposit",
    name: "offline-deposit-process",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.orderProcess.offlineDepositProcess"
    },
    component: () =>
      import(
        /* webpackChunkName: "offline-deposit-process" */ "@/components/OrderProcessPage/Deposit/OfflineDeposit/index"
      )
  },
  {
    path: ":id/deposit/resubmit",
    name: "deposit-resubmit-process",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.orderProcess.depositResubmitProcess"
    },
    component: () =>
      import(
        /* webpackChunkName: "withdrawal-rial-process" */ "@/components/OrderProcessPage/Deposit/ResubmitDeposit/index"
      )
  },
  {
    path: ":id/withdrawal",
    name: "withdrawal-process",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.orderProcess.withdrawalProcess"
    },
    component: () =>
      import(
        /* webpackChunkName: "withdrawal-process" */ "@/components/OrderProcessPage/Withdrawal/index"
      ),
    children: [
      {
        path: "rial",
        name: "withdrawal-rial-process",
        meta: {
          transitionName: "slide",
          appBarTitle: "pageTitles.orderProcess.withdrawalRialProcess"
        },
        component: () =>
          import(
            /* webpackChunkName: "withdrawal-rial-process" */ "@/components/OrderProcessPage/Withdrawal/Rial/index"
          )
      },
      {
        path: "crypto",
        name: "withdrawal-crypto-process",
        meta: {
          transitionName: "slide",
          appBarTitle: "pageTitles.orderProcess.withdrawalCryptoProcess"
        },
        component: () =>
          import(
            /* webpackChunkName: "withdrawal-crypto-process" */ "@/components/OrderProcessPage/Withdrawal/Crypto/index"
          )
      }
    ]
  },
  {
    path: ":token/exchange",
    name: "exchange-process",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.orderProcess.exchangeProcess"
    },
    component: () =>
      import(
        /* webpackChunkName: "exchange-process" */ "@/components/OrderProcessPage/Exchange/index"
      )
  },
  {
    path: ":id/transfer",
    name: "transfer-process-id",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.orderProcess.transferProcess"
    },
    async beforeEnter(to, from, next) {
      UserService.getInfo().then(res => {
        if (res.data.data.is_market_platform_active) {
          next();
        } else {
          next({
            name: "dashboard"
          });
        }
      });
    },
    component: () =>
      import(
        /* webpackChunkName: "transfer-process" */ "@/components/OrderProcessPage/Transfer/index"
      )
  },
  {
    path: ":coin/transfer",
    name: "transfer-process",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.orderProcess.transferProcess"
    },
    async beforeEnter(to, from, next) {
      UserService.getInfo().then(res => {
        if (res.data.data.is_market_platform_active) {
          next();
        } else {
          next({
            name: "dashboard"
          });
        }
      });
    },
    component: () =>
      import(
        /* webpackChunkName: "transfer-process" */ "@/components/OrderProcessPage/Transfer/index"
      )
  },
  {
    path: ":id/fiats",
    name: "fiat-process",
    meta: { transitionName: "slide" },
    component: () =>
      import(
        /* webpackChunkName: "fiat-process" */ "@/components/OrderProcessPage/PerfectMoney/index"
      ),
    children: [
      {
        path: "buy",
        name: "fiat-buy-process",
        meta: {
          transitionName: "slide",
          appBarTitle: "pageTitles.perfectMoney.buy"
        },
        component: () =>
          import(
            /* webpackChunkName: "fiat-buy-process" */ "@/components/OrderProcessPage/PerfectMoney/Buy/index"
          )
      },
      {
        path: "sell",
        name: "fiat-sell-process",
        meta: {
          transitionName: "slide",
          appBarTitle: "pageTitles.perfectMoney.sell"
        },
        component: () =>
          import(
            /* webpackChunkName: "fiat-sell-process" */ "@/components/OrderProcessPage/PerfectMoney/Sell/index"
          )
      },
      {
        path: "resubmit-sell",
        name: "fiat-resubmit-sell-process",
        meta: {
          transitionName: "slide",
          appBarTitle: "pageTitles.perfectMoney.sell"
        },
        component: () =>
          import(
            /* webpackChunkName: "fiat-resubmit-sell-process" */ "@/components/OrderProcessPage/PerfectMoney/ResubmitSell/index"
          )
      }
    ]
  }
];
